import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M13 4v4c-6.575 1.028 -9.02 6.788 -10 12c-.037 .206 5.384 -5.962 10 -6v4l8 -7l-8 -7","key":"svg-0"}]]

const IconShare3 = createReactComponent('outline', 'share-3', 'Share3', __iconNode);

export default IconShare3;